"use strict";export class OverlayCloseEvent extends Event{constructor({root:e}){super("sp-overlay-close",{bubbles:!0,composed:!0});this.root=e}}
//# sourceMappingURL=overlay-events.js.map
